import axios from 'axios'
import env from '../env'
import { version } from '../../package.json'
import { logout } from '../services/auth'
import router from '../router/index'

export const instance = axios.create({
  baseURL: env.baseURL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    AppName: 'miib',
    AppVersion: version,
  },
})

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.value.name !== 'Login') {
        logout()
        router.push('/login')
      }
    } else if (!error.response && router.currentRoute.value.name !== 'NoNetwork') {
      router.push('/no-network')
    }
    return Promise.reject(error)
  },
)
